
export const PAGES_DATA = 
[
	{
		"index":0,
		"chapter":"소개",
		"data": [
			{
				"subject": "서문",
				"uid": 1,
			},
		]
	},
	{
		"index":1,
		"chapter":"우주는 어떻게 둥글어가나",
		"data": [
			{
				"subject": "우주변화의 틀 생장염장",
				"uid": 101
			},
			{
				"subject": "지구1년은 12만9천6백도 우주 일년은 12만9천6백년",
				"uid": 102
			},
			{
				"subject": "천지는 사람농사를 짓는다",
				"uid": 103
			},			
			{
				"subject": "우주변화원리는 누구라도 배워야 ",
				"uid": 104
			},
			{
				"subject": "가을은 상생의 세상이다",
				"uid": 105
			},
			{
				"subject": "천리가 성숙됨에 따라 인류 역사도 성숙된다",
				"uid": 106
			},
			{
				"subject": "이제까지 봄여름의 세상을 살아왔다",
				"uid": 107
			},
			{
				"subject": "봄에는 내고春生 가을에는 죽이고秋殺",
				"uid": 108
			},
			{
				"subject": "지금은 사람 씨종자를 추리는 하추교역기",
				"uid": 109
			},
			{
				"subject": "때를 알아야 살길을 찾는다",
				"uid": 110
			},
			{
				"subject": "장차 지구의 공전궤도가 바뀐다",
				"uid": 111,
			},
			{
				"subject": "개벽은 왜  일어나는가",
				"uid": 112,
			},
			{
				"subject": "여름과 가을을 이어주는 미토未土",
				"uid": 113, 
			}
		]
	}, {
		"index":2,
		"chapter":"기존 문화권을 매듭짓고 새 세상을 여신 참하나님 증산상제님",
		"data":[
			{
				"subject": "사람 씨종자를 추수하시는 참하나님",
				"uid": 201
			},
			{
				"subject": "상제님은 삼계를 마름질하는 주재자 하나님",
				"uid": 202
			},
			{
				"subject": "상제님이 오시는 땅 ",
				"uid": 203, 
				"hidden": 1,
			},
			{
				"subject": "전 인류와 뭇 신명의 하나님",
				"uid": 204
			},
			{
				"subject": "상제님이 이 땅에 강세하기까지",
				"uid": 205
			},
			{
				"subject": "강증산 상제님으로 오시다",
				"uid": 206
			},
			{
				"subject": "인생의 총 결론은 참하나님을 만나는 것",
				"uid": 207
			}
		]
	}, {
		"index":3,
		"chapter":"왜 제 조상을 섬겨야 하는가", 
		"data": [
			{
				"subject": "가을은 제 본모습을 찾는 때",
				"uid": 301
			},
			{
				"subject": "시조 할아버지의 유전인자가 내 몸에 전해져 있다",
				"uid": 302
			},
			{
				"subject": "유전인자는 절대로 바꾸지 못 한다",
				"uid": 303, 
				"hidden": 1,
			},
			{
				"subject": "자손이 살아남아야 조상도 같이 산다",
				"uid": 304, 
				"hidden": 1,
			},
			{
				"subject": "그 뿌리를 북돋아주면 그 가지가 번성한다",
				"uid": 305
			},
			{
				"subject": "제각기 제 조상이 제 하나님",
				"uid": 306
			},
			{
				"subject": "효는 모든 행실의 근본",
				"uid": 307
			},
			{
				"subject": "좋은 조상의 좋은 자손이라야 살아남는다",
				"uid": 308,
				"hidden": 1,
			},
			{
				"subject": "5백석과 맞바꾼 아들의 목숨",
				"uid": 309,
				"hidden": 1,
			},
			{
				"subject": "제 뿌리를 부정하고 배반하는 자는",
				"uid": 310,
				"hidden": 1,
			},
		]
	}, {
		"index":4,
		"chapter":"신명공사로 새 세상을 여셨다",
		"data": [
			{
				"subject": "신명은 육신이 없는 사람",
				"uid": 401
			},
			{
				"subject": "원한 맺힌 신명들이 천지에 가득 찼다",
				"uid": 402
			},
			{
				"subject": "먼저 신명들의 원한부터 풀어주어야",
				"uid": 403, 
			},
			{
				"subject": "신명정부를 조직하여 앞 세상 틀을 짜심",
				"uid": 404
			},
			{
				"subject": "이 세상 둥글어가는 설계도 천지공사",
				"uid": 405
			},
			{
				"subject": "천지공사는 세운과 도운으로 대분된다 ",
				"uid": 406
			},
			{
				"subject": "파리 죽은 귀신도 원망이 붙지 않은 천지공사",
				"uid": 407,
				"hidden": 1,
			},
			{
				"subject": "9년 공사 실현에 백 년이 걸린다",
				"uid": 408,
				"hidden": 1,
			}
		]
	}, {
		"index":5,
		"chapter":"세계정세는 어떻게 변해왔나",
		"data":[
			{
				"subject": "우리나라는 바둑판",
				"uid": 501
			},
			{
				"subject": "세계정세를 다섯 신선이 바둑 두는 형국으로",
				"uid": 502
			},
			{
				"subject": "애기판 총각판 상씨름판으로 펼쳐진다",
				"uid": 503
			},
			{
				"subject": "조선을 일본에 의탁하심",
				"uid": 504, 
				"hidden": 1,
			},
			{
				"subject": "애기판 씨름은 제1차 세계대전",
				"uid": 505,
				"hidden": 1,
			},
			{
				"subject": "총각판 씨름은 제2차 세계대전",
				"uid": 506,
				"hidden": 1,
			},
			{
				"subject": "상씨름은 상투쟁이끼리의 대결",
				"uid": 507,
				"hidden": 1,				
			}
		]		
	}, {
		"index":6,
		"chapter":"상제님의 도는 어떻게 굽이쳐왔나",
		"data": [
			{
				"subject": "세 번 변해서 매듭이 지어진다",
				"uid": 601
			},
			{
				"subject": "첫 번째 판 ",
				"uid": 602
			},
			{
				"subject": "두 번째 판 ",
				"uid": 603
			},
			{
				"subject": "세 번째 판으로 넘어가는 마디",
				"uid": 604, 
				"hidden": 1,			
			},
			{
				"subject": "세 번째 판",
				"uid": 605,
				"hidden": 1,
			},
			{
				"subject": "상제님의 상생문화로 세계가 하나 된다",
				"uid": 606,
				"hidden": 1,
			}
		]
	}, {
		"index":7,
		"chapter": "태을주로 천하사람을 살린다",
		"data": [
			{
				"subject": "장차 괴병이 엄습한다",
				"uid": 701
			},
			{
				"subject": "천하사람을 살리는 의통",
				"uid": 702
			},
			{
				"subject": "의통은 상제님 9년 천지공사의 총 결론",
				"uid": 703
			},
			{
				"subject": "의통은 마패와 같은 것",
				"uid": 704,
				"hidden": 1,				
			},
			{
				"subject": "의통의 바탕은 태을주",
				"uid": 705,
				"hidden": 1,
			},
			{
				"subject": "태을주의 뜻",
				"uid": 706,
				"hidden": 1,
			},
			{
				"subject": "생명의 주문 태을주를 읽어야 산다",
				"uid": 707,
				"hidden": 1,
			},
			{
				"subject": "태을주로 매듭을 짓는다",
				"uid": 708,
				"hidden": 1,				
			},
			{
				"subject": "태을주는 모든 것을 이루어주는 여의주",
				"uid": 709,
				"hidden": 1,
			},
			{
				"subject": "태을주는 제1의 생명, 내 생명은 제2의 생명",
				"uid": 710,
				"hidden": 1,
			},			
			{
				"subject": "수련이란 자기 심법을 연마하는 것",
				"uid": 711,
				"hidden": 1,
			},
			{
				"subject": "수승화강으로 체질이 개선된다",
				"uid": 712,
				"hidden": 1,
			},
			{
				"subject": "수행의 올바른 자세",
				"uid": 713, 
				"hidden": 1,				
			},
			{
				"subject": "수도 이전에 심법이 발라야",
				"uid": 714,
				"hidden": 1,
			}
		]
	}, 
	{
		"index":8,
		"chapter": "지상선경의 새 시대가 열린다",
		"data": [
			{
				"subject": "동양은 양으로서 무형문화요 서양은 음으로서 유형문화다 ",
				"uid": 801
			},
			{
				"subject": "음양오행 속에 세상 이치가 다 들어 있다",
				"uid": 802,
				"hidden": 1,
			},
			{
				"subject": "물질문화와 정신문화가 합일된 결실문화가 열린다 ",
				"uid": 803,
				"hidden": 1,
			},
			{
				"subject": "배우지 않고도 만사를 안다",
				"uid": 804, 
				"hidden": 1,				
			},
			{
				"subject": "억압도 부패도 없는 군사부 일체의 세상",
				"uid": 805,
				"hidden": 1,
			},
			{
				"subject": "신인이 합일하는 인존문화가 열린다",
				"uid": 806,
				"hidden": 1,
			},
			{
				"subject": "죽는 생명을 인존의 진리가 살린다",
				"uid": 807, 
				"hidden": 1,				
			},
			{
				"subject": "모두가 행복을 구가하는 불로장생의 세상",
				"uid": 808,
				"hidden": 1,
			},
			{
				"subject": "지상선경 현실선경 조화선경이 열린다",
				"uid": 809,
				"hidden": 1,
			}
		]
	}, 
	{
		"index":9,
		"chapter": "우주의 결실은 인간",
		"data": [
			{
				"subject": "상제님 일꾼은 천지의 대역자",
				"uid": 901,
			},
			{
				"subject": "천지의 대역자가 되려면",
				"uid": 902,
				"hidden": 1,
			},
			{
				"subject": "인류 역사의 참된 봉사자",
				"uid": 903,
				"hidden": 1,
			},
			{
				"subject": "나도 살고 남도 살리자",
				"uid": 904,
				"hidden": 1,
			},
			{
				"subject": "혈식을 받는 남조선배 뱃사공",
				"uid": 905, 
				"hidden": 1,				
			},
			{
				"subject": "성공의 밑천은 일심",
				"uid": 906, 
				"hidden": 1,				
			},
			{
				"subject": "이 시대를 사는 사람은 ",
				"uid": 907,
				"hidden": 1,
			},
			{
				"subject": "증산도는 천지를 담는 그릇",
				"uid": 908,
				"hidden": 1,
			}
		]
	}
];

